// Admin-managed announcements: the announcement marquee ticker and the popup ads.
// Used as the fallback while no API is configured (preview mode).

export const marqueeMessages = [
  { id: "mq-1", message: "List your business free and get found by thousands of local customers.", linkUrl: "/list-your-business", linkLabel: "Add your listing", color: "brand", displayOrder: 1, isActive: true },
  { id: "mq-2", message: "Festive offer: 20% off the Business plan this month only.", linkUrl: "/listing-plans", linkLabel: "See plans", color: "red", displayOrder: 2, isActive: true },
  { id: "mq-3", message: "Now covering Mysore, Mandya, Chamarajanagar & Kodagu (Coorg).", linkUrl: "/locations", linkLabel: "Browse areas", color: "green", displayOrder: 3, isActive: true },
  { id: "mq-4", message: "Explore the best tourist spots across the Mysore region.", linkUrl: "/tourist-spots", linkLabel: "Explore now", color: "terracotta", displayOrder: 4, isActive: true },
  { id: "mq-5", message: "24x7 emergency helplines - police, ambulance, fire and more.", linkUrl: "/emergency-services", linkLabel: "View helplines", color: "dark", displayOrder: 5, isActive: true },
];

export const popupAds = [
  {
    id: "pa-1",
    title: "Grow your business with a featured listing",
    mediaType: "image",
    mediaUrl:
      "https://readdy.ai/api/search-image?query=Warm%20inviting%20flat%20illustration%20of%20a%20small%20local%20Indian%20storefront%20glowing%20at%20dusk%20with%20a%20prominent%20featured%20star%20badge%2C%20golden%20and%20terracotta%20color%20palette%2C%20clean%20minimal%20composition%20with%20generous%20negative%20space%2C%20editorial%20poster%20style&width=1000&height=750&seq=myyp-popup-featured&orientation=landscape",
    linkUrl: "/listing-plans",
    linkLabel: "See listing plans",
    targetPages: ["all"],
    frequencyCap: 3,
    delaySeconds: 2,
    impressions: 0,
    startAt: "",
    endAt: "",
    isActive: true,
    priority: 20,
  },
  {
    id: "pa-2",
    title: "Discover the hidden gems of Mysore",
    mediaType: "image",
    mediaUrl:
      "https://readdy.ai/api/search-image?query=Artistic%20stylised%20illustration%20of%20a%20grand%20palace%20silhouette%20against%20a%20warm%20sunset%20sky%20with%20rolling%20hills%2C%20golden%20amber%20and%20deep%20teal%20tones%2C%20travel%20poster%20aesthetic%2C%20minimal%20clean%20layout%20with%20empty%20space%20for%20a%20headline&width=1000&height=750&seq=myyp-popup-tourist&orientation=landscape",
    linkUrl: "/tourist-spots",
    linkLabel: "Explore tourist spots",
    targetPages: ["tourist-spots", "home"],
    frequencyCap: 2,
    delaySeconds: 3,
    impressions: 0,
    startAt: "",
    endAt: "",
    isActive: false,
    priority: 10,
  },
];